import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/Header";
import HeadingSection from "../GenerateTokenHeadingSection";
import { CopyToClipboard } from "react-copy-to-clipboard";
import JSONPretty from "react-json-pretty";
import { Internal_Token } from "../../../../actions/auth";
import { encrypt } from "../../../../utils/encodingdecoding";
import introJs from 'intro.js';
import 'intro.js/introjs.css'; 
import {documentDropdown,profileDropdown} from '../../../../actions/intro'
import { useDispatch, useSelector } from 'react-redux';
import ModalCard from "../../../layout/ModalCard";
import { useNavigate } from "react-router-dom";

import {cardUrl} from '../../../../utils/url'
//import ModalCard from "../../layout/ModalCard";
const GenerateAccessKeyAPI = () => {
    const [state, setState] = useState({
        responseCopied: false,
        requestCopied: false,
        isClicked: false,
        loading: false,
        catchErr: false,
    });
    const navigate = useNavigate();
    const [showModal,setshowModal]=useState(false)
    const intro = introJs();
    const dispatch = useDispatch();
    const modalOpen = useSelector(state => state.intro.modalOpen);
    const { requestCopied, responseCopied, loading, catchErr } = state;
    const handleCopy = (copy) => {
        copy === "request" ? setState({ ...state, requestCopied: true }) : setState({ ...state, responseCopied: true });
        setTimeout(() => {
            copy === "request" && setState({ ...state, requestCopied: "" });
        }, 1000);
        setTimeout(() => {
            copy === "response" && setState({ ...state, responseCopied: "" });
        }, 1000);
    };
    const [responseText, setResponseText] = useState(" ");
    const [requestText, setRequestText] = useState(`{
		"formData" : {
			"client_id" : "Enter client id",
			"grant_type" : "Enter grant_type ",
			"client_secret" : "Enter client_secret"
		}
	}`);

    useEffect(() => {
        let catchError;
        if (catchErr) {
            catchError = setTimeout(() => {
                setState({ catchErr: false });
            }, 2000);
        }
        return () => {
            clearTimeout(catchError);
        };
    }, [catchErr]);
    // const requestText = `{
    // 	"url" : "https://idsrvnovusstaging.cladev.com/connect/token",
    // 	"method" : "post",
    // 	"headers" : {
    // 		"Authorization" : "Bearer ",
    // 		"Accept" : "application/json",
    // 		"Content-Type" : "application/json"
    // 	},
    // 	"formData" : {
    // 		"client_id" : "sample",
    // 		"grant_type" : "client_credentials",
    // 		"client_secret" : "sample"
    // 	}
    // }`;

    // let responseText;
    // if (isClicked) {
    //     responseText = `{
    // 	"access_token" : "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",
    // 	"expires_in" : "3600",
    // 	"token_type" : "Bearer"
    // }`;
    // } else {
    //     responseText = " ";
    // }
    const handleChange = (e) => {
        setRequestText(e.target.value);
    };
    const handleClick = () => {
        setState({ ...state, disable: true, loading: true });
        try {
            let temp = JSON.parse(requestText);
            let body = temp.formData;
            let tempId = encrypt(body.client_id);
            let tempSecretKey = encrypt(body.client_secret);
            let tempbody = {
                clientid: tempId,
                clientsecret: tempSecretKey,
                grant_type: "client_credentials",
            };

            const response = Internal_Token(tempbody);
            response.then((res) => {
                setResponseText(res);
                setState({ ...state, disable: false, loading: false });
            });
        } catch (error) {
            setState({ ...state, catchErr: true });
        }
    };
    let complete=false
    useEffect(() => { 
        const handleLoad=()=>{ 
       // temp=1
    
         const steps = [
            {
                element: document.getElementById('documentationm'),
                title: 'Documentation',
                intro: "Access thorough documentation and resources for optimal utilization of the loyalty software"
              },
              {
                element:document.getElementById('help_FAQ'),
                title: 'Help and FAQ  ',
                intro: "Get answers to common queries and seek help through the dedicated Help and FAQ section",
             
              },
              
    
         ]
         intro.setOptions({
             steps: steps,
             exitOnOverlayClick: false,
             tooltipClass: 'customTooltip'
           });
     
         intro.start();
         } 
         if( localStorage.getItem('firstLogin')){
            dispatch(documentDropdown(true))
         setTimeout(()=>{
            handleLoad()
         },500)
        }
         
       
    }, []);
       intro.oncomplete(function(element) {
     complete=true

        dispatch(documentDropdown(false))
        dispatch(profileDropdown(false))
        localStorage.setItem('firstLogin','')
    });
    intro.onexit(() => {
        setshowModal(true)
        localStorage.setItem('firstLogin','')
        dispatch(documentDropdown(false))
        dispatch(profileDropdown(false))
      });

    return (
        <>
          {showModal && <ModalCard/>}
            <Header name={"Generate Access Key"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__apiPlaygroundBox">
                        <div className="dashboard__apiPlaygroundHeading">
                            <h2>
                                <span className="badge rounded-pill bg-primary">POST</span> Generate Access Key
                            </h2>
                        </div>
                        <div className="dashboard__apiPlaygroundBottom">
                            <div className="dashboard__apiPlaygroundEndpoint">
                            <p>
                                    <span>API Endpoint</span>
                                    <Link to="#!">https://idsrvsaas.cladev.com/connect/token</Link>
                                </p>
                            </div>
                        </div>
                        <div className="dashboard__apiPlaygroundCardMain">
                            {catchErr && (
                                <div className="alert alert-danger" role="alert">
                                    Invalid JSON format
                                </div>
                            )}
                        </div>
                        <div className="dashboard__apiPlaygroundCardMain">
                            <div className="dashboard__apiPlaygroundCardHead">
                                <h3>API Simulate</h3>
                            </div>
                            <div className="dashboard__apiPlaygroundCardBox">
                                <div className="dashboard__apiPlaygroundLeft">
                                    <div className="dashboard__requestSection">
                                        <div className="dashboard__header">
                                            <div className="dashboard__left">
                                                <h5>Request</h5>
                                            </div>
                                            <div className="dashboard__right">
                                                <CopyToClipboard text={requestText} onCopy={() => handleCopy("request")}>
                                                    <Link className="btn btn-light" to="">
                                                        {requestCopied ? "Copied" : "Copy"}
                                                    </Link>
                                                </CopyToClipboard>
                                            </div>
                                        </div>
                                        <div className="dashboard__body" id="APICodeBox">
                                            <textarea id="api" value={requestText} onChange={handleChange}></textarea>
                                        </div>
                                        <div className="dashboard__footer">
                                            <button
                                                type="button"
                                                className="btn btn-light rounded-circle"
                                                title="Get Response"
                                                disabled={loading ? true : false}
                                                // onClick={() => {
                                                //     // setState({ ...state, isClicked: true });
                                                //     handleClick
                                                // }}
                                                onClick={handleClick}
                                            >
                                                <i className="fa-solid fa-play"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard__apiPlaygroundRight">
                                    <div className="dashboard__responseSection">
                                        <div className="dashboard__header">
                                            <div className="dashboard__left">
                                                <h5>Response</h5>
                                            </div>
                                            <div className="dashboard__right">
                                                <CopyToClipboard text={responseText} onCopy={() => handleCopy("response")}>
                                                    <Link className="btn btn-dark" to="">
                                                        {responseCopied ? "Copied" : "Copy"}
                                                    </Link>
                                                </CopyToClipboard>
                                            </div>
                                        </div>
                                        <div className="dashboard__body" id="APICodeBox">
                                            {loading ? (
                                                <div className="mainPreloaderMain">
                                                    <div className="mainPreloader">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <JSONPretty id="json-pretty" data={responseText} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <HeadingSection />
                    </div>
                </div>
            </div>
        </>
    );
};

export default GenerateAccessKeyAPI;
